import { useQuery } from '@tanstack/react-query'
import { getJetTimesheetPhotoUrl } from 'api/admin/jet/getJetTimesheetPhotoUrl'
import { jetKey } from './keys'

export function useJetTimesheetPhoto(
  associationId: number,
  { enabled = false }: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: [...jetKey, associationId, 'timesheetPhotoUrl'],
    queryFn: () => getJetTimesheetPhotoUrl(associationId),
    enabled,
    retry: false,
    staleTime: Infinity,
  })
}
